<script>
import TenantServicesBase from "@/components/TenantServicesBase";
export default {
  extends: TenantServicesBase,
  data: () => ({
    configType: 'SchemePortal',
    apiSuffix: 'schemeportal',
    tenantDataKey: 'schemeportal_tenant',
    urlKey: 'schemeportal_url',
    generateUrlString: '.schemeportal.co.uk'

  }),
  methods: {
    getEnvType: function(type) {
      if (type === 'web') {
        return 6;
      }
    },
  },
  name: "tenant-schemeportal-service"
}
</script>
